import { _, toggleClasses } from '../utils.js'
export default class PasswordReveal {
    constructor(el) {
        this.el = el
        this.trigger = el.querySelector(_('password-trigger', 'element').str())
        this.trigger.addEventListener('click', this.togglePasswordVisibility)
    }

    togglePasswordVisibility = (e) => {
        const currentTrigger = e.currentTarget
        const currentInput = currentTrigger.parentNode.querySelector(
            _('password-input', 'element').str(),
        )
        const currentIcon = [
            ...currentTrigger.parentNode.querySelectorAll(
                _('password-icon', 'element').str(),
            ),
        ]
        const typeState =
            currentInput.getAttribute('type') === 'password'
                ? 'text'
                : 'password'

        toggleClasses(currentIcon, 'u-hidden')
        currentInput.setAttribute('type', typeState)
    }
}
